import { Routes } from '@angular/router';

import { pendingChangesGuard } from './modules/core/guards/pending-changes.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@core').then(({ HeaderlessLayoutComponent }) => HeaderlessLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('@home').then(({ HomePage }) => HomePage),
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('@core').then(({ MainLayoutComponent }) => MainLayoutComponent),
    children: [
      {
        path: 'new-ticket',
        canDeactivate: [pendingChangesGuard],
        loadComponent: () =>
          import('@tickets/create-ticket').then(({ CreateTicketPage }) => CreateTicketPage),
      },
      {
        path: 'my-tickets',
        loadComponent: () =>
          import('@tickets/tickets-list').then(({ TicketsListPage }) => TicketsListPage),
      },
      {
        path: 'chat',
        loadComponent: () => import('./modules/chat/chat.page').then(({ ChatPage }) => ChatPage),
      },
      {
        path: 'edit-ticket/:ticketNumber',
        canDeactivate: [pendingChangesGuard],
        loadComponent: () =>
          import('@tickets/edit-ticket').then(({ EditTicketPage }) => EditTicketPage),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
